import Component from './component';
import fixtures from './fixtures';
import transform from './transformer';

const RadioButton = (props) => <Component {...transform(props)} />;

export default RadioButton;

export { Component as component, fixtures, transform as transformer };
